import { action as apiAction } from 'api/Api'
import {
  positionItem,
  addItem,
  removeItem
} from '../redux/elements'
import sweetalert from 'sweetalert2'
import { optimisticDispatch } from 'utils/sagas'

type Payload = {
  cardId: number
  subCardId: number
  subCardGroupId: number
  position: number
}

const requestPositionSubCard = (payload: Payload) => async (dispatch, getState) => {
  const { cardId, subCardId, subCardGroupId, position } = payload

  let currentSubCardGroupId

  const state = getState()

  const elements = state['view-card'].elements[cardId].elements
  const elementsById = state['view-card'].elements.elementsById

  for (let i = 0, length = elements.length; i < length; i++) {
    const subCardGroup = elementsById[elements[i]]

    if (subCardGroup.elementName === '/Data/SubCardGroup' && subCardGroup.items.indexOf(subCardId) !== -1) {
      currentSubCardGroupId = subCardGroup.id
      break
    }
  }

  if (subCardGroupId === currentSubCardGroupId) {
    const optimisticAction = optimisticDispatch(dispatch, positionItem({
      elementId: subCardGroupId,
      itemId: subCardId,
      index: position
    }))

    try {
      await apiAction('PositionSubCardGroupItem', {
        id: subCardId,
        position
      })

      optimisticAction.commit()
    } catch (error) {
      optimisticAction.revert()

      throw error
    }
  } else {
    const optimisticAction = optimisticDispatch(dispatch, [
      removeItem({
        elementId: currentSubCardGroupId,
        itemId: subCardId
      }),
      addItem({
        elementId: subCardGroupId,
        itemId: subCardId,
        index: position
      })
    ])

    try {
      await apiAction('ChangeSubCardGroupItemParent', {
        containerFromId: currentSubCardGroupId,
        containerToId: subCardGroupId,
        id: subCardId,
        position
      })

      optimisticAction.commit()
    } catch (error) {
      optimisticAction.revert()

      if (error.code === 300) {
        const state = getState()
        try {
          await sweetalert({
            text: state.kanbo.locale.messages['DOCUMENT_LIST_ADD_DOCUMENT_DUPLICATE'],
            type: 'info'
          })
        } catch (e) {}
      } else {
        throw error
      }
    }
  }
}

export default requestPositionSubCard
